export default "__VITE_ASSET__CCU_jOxE__"